<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- <a-form-model-item label="存储池" prop="enterpriseOwnPoolId" v-if="userTentant.type !== 1">
        <a-select show-search :allowClear="true" v-model="form.enterpriseOwnPoolId" placeholder="请选择"
          option-filter-prop="children" :filter-option="filterOption" @change="handleQi">
          <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <!-- <a-form-model-item label="存储池" prop="enterpriseOwnPoolId">
        <div class="input_d">
          <a-input v-model="enterpriseOwnPool" placeholder="请选择" disabled :maxLength="50" />
          <a-button type="primary" @click="$refs.publicForm.handleAdd(5)" style="margin-left: 20px;">
            选择
          </a-button>
          <a-input v-model="form.enterpriseOwnPoolId" placeholder="请选择" disabled :maxLength="50"  v-show="shows"/>

        </div>
      </a-form-model-item> -->
      <a-form-model-item label="接收方代理" prop="agentTenantId">
        <div class="input_d">
          <a-input v-model="name" placeholder="请选择" disabled :maxLength="50" />
          <a-button type="primary" @click="$refs.publicForm.handleAdd(1, firmId)" style="margin-left: 20px">
            选择
          </a-button>
          <a-input v-model="form.agentTenantId" placeholder="请选择" disabled :maxLength="50" v-show="shows" />
        </div>
      </a-form-model-item>
      <a-form-model-item label="分配总容量" prop="allocateCapacity">
        <a-input
          v-model="form.allocateCapacity"
          oninput="
      value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '');
      if (value && parseFloat(value) < 5) value = '5';
      if (value === '' || value === '.') value = '';
    "
          placeholder="请输入MB（最小值为5）"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <!-- <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
    <publicForm ref="publicForm" @changeAgent="changeAgent" @changeCun="changeCun"></publicForm>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, putObj } from '@/api/VR/assignAgents'
import parameter from '@/mixins/parameter'
import publicForm from './publicForm'
export default {
  name: 'CreateForm',
  components: { publicForm },
  mixins: [parameter],
  props: {
    userList: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      submitLoading: false,
      shows: false,
      showLoading: false,
      enterpriseOwnPool: '',
      data: [],
      formTitle: '',
      firmId: '',
      // 表单参数
      form: {
        id: undefined,
        allocateCapacity: 5,
        agentTenantId: undefined,
        sort: 99,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      name: '',
      rules: {
        enterpriseOwnPoolId: [{ required: true, message: '请选择存储池', trigger: 'blur' }],
        agentTenantId: [{ required: true, message: '请选择接收方代理', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        packageType: [{ required: true, message: '请选择套餐类型', trigger: 'blur' }],
        unitPrice: [{ required: true, message: '请输入单价(元/GB)', trigger: 'blur' }],
        price: [{ required: true, message: '请输入套餐价格', trigger: 'blur' }],
        validDays: [{ required: true, message: '请输入有效期(天)', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.infoUser)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 点击更新
    changeAgent(e) {
      console.log(e, '顶顶顶顶')
      this.form.agentTenantId = e.id
      this.name = e.name
    },
    // 点击更新存储池
    changeCun(e) {
      if (e.id) {
        this.form.enterpriseOwnPoolId = e.id
        this.enterpriseOwnPool = e.packageName
      } else {
        this.form.enterpriseOwnPoolId = ''
        this.enterpriseOwnPool = ''
      }
    },
    // 点击企业发生改变
    handleQi(e) {
      console.log(e, '顶顶顶顶')
      this.firmId = e
      this.form.agentTenantId = undefined
      this.name = ''
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        allocateCapacity: 5,
        agentTenantId: undefined,
        sort: 99,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '分配代理'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          console.log(this.form, 'ddd点点滴')
          addObj(this.form)
            .then((response) => {
              this.$message.success('新增成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
          // if (this.form.id !== undefined) {
          //   putObj(this.form)
          //     .then((response) => {
          //       this.$message.success('修改成功', 3)
          //       this.open = false
          //       this.$emit('ok')
          //     })
          //     .finally(() => {
          //       this.submitLoading = false
          //       this.showLoading = false
          //     })
          // } else {
          //   addObj(this.form)
          //     .then((response) => {
          //       this.$message.success('新增成功', 3)
          //       this.open = false
          //       this.$emit('ok')
          //     })
          //     .finally(() => {
          //       this.submitLoading = false
          //       this.showLoading = false
          //     })
          // }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 0 !important;
}

.input_d {
  display: flex;
  align-items: center;
}
</style>
